import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import React, { useEffect, useRef, useState } from "react";
import { IRoleMast } from "../../models/RoleMast";
import { Fetch, ILazyParams } from "../../shared/Fetch";
import { Search } from "../../shared/Search";
import { EmptyRole } from "./EmptyRole";
import { PagePermissionForm } from "./PagePermissionForm";
import { IModel } from "./RoleMast";
import { IPermissionProps } from "../../models/Login";
import { format } from "date-fns";
import { AddSubRoleForm } from "./AddSubRole";

interface Iprops {
    setModal: (modal: IModel) => void,
    toast: any,
    reload: boolean,
    permissions: IPermissionProps
}
export interface IModel2 {
    open: boolean,
    singleData: IRoleMast
}


export const Table = (props: Iprops) => {
    const [modal2, setModal2] = useState({ singleData: {}, open: false } as IModel2);
    const hideDialog2 = () => {
        setModal2({ singleData: {}, open: false });
    };

    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IRoleMast>, loading: boolean });
    const [totalRecords, setTotalRecords] = useState(0);
    const [globalFilter, setGlobalFilter] = useState<string | null>(null);
    const [subRoleForm, setOpenSubRoleForm] = useState({ singledata: {}, open: false } as { singledata: IRoleMast, open: boolean });

    const dt = useRef<any>(null);
    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 25,
        page: 1,
        sortField: 'role_ID',
        sortOrder: -1
    });

    useEffect(() => {
        getTableDataCount();
        loadTableData();
    }, [globalFilter, lazyParams, props.reload]);

    const onPage = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const onSort = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const getTableDataCount = async () => {
        const response = await Fetch("Role_Mast/count", "GET", null, `filter=${globalFilter}`, props.toast);
        if (response) {
            const count: number = parseInt(await response.text(), 10);
            setTotalRecords(count);
        }
    }

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Role_Mast", "GET", null, `lazyParams=${JSON.stringify(lazyParams)}&filter=${globalFilter}`, props.toast);
        if (response) {
            const data: Array<IRoleMast> = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }

    const openNew = () => {
        props.setModal({ open: true, singleData: EmptyRole });
    };


    const openEdit = (rowDatauser: IRoleMast) => {
        props.setModal({ open: true, singleData: rowDatauser });
    };

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="my-2">
                    <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                </div>
            </React.Fragment>
        );
    };

    const rightToolbarTemplate = () => {
        return (
            props.permissions.is_Export ?
                <React.Fragment>
                    <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} />
                </React.Fragment> : ''
        );
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Manage Roles</h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                <Search setSearch={setGlobalFilter} />
            </span>
        </div>
    );

    const openEditPagePermission = (rowData: IRoleMast) => {
        setModal2({ singleData: rowData, open: true });
    }

    const role_NameBodyTemplate = (rowData: IRoleMast) => {
        return (
            <span onClick={() => openEditPagePermission(rowData)} className="cursor-pointer text-cyan-700 underline">
                {rowData.role_Name}
            </span>
        );
    };
    const hideHistory = () => {

        setOpenSubRoleForm({ singledata: {}, open: false });

    }
    const openAllocationForm = (rowDatauser: IRoleMast) => {
        setOpenSubRoleForm({ singledata: rowDatauser, open: true });
    }
    const actionBodyTemplate = (rowData: IRoleMast) => {
        return (
            <div className="actions">
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success p-button-text mr-1" onClick={() => openEdit(rowData)} />
                <Button icon="pi pi-plus" className="p-button-rounded p-button-success bg-primary mr-1" onClick={() => openAllocationForm(rowData)} />
            </div>
        );
    };

    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }} exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                ref={dt} size="small"
                value={tableData.tableData} lazy dataKey="id"
                paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[25, 50, 100, 200]}
                totalRecords={totalRecords} onPage={onPage}
                onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                emptyMessage="No Roles found."
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                header={header}
                loading={tableData.loading}
            >
                <Column field="role_ID" header="Role ID" sortable />
                <Column field="role_Name" header="Role Name" body={role_NameBodyTemplate} sortable />
                <Column field="role_Description" header="Description" />
                <Column body={actionBodyTemplate} />
            </DataTable>
            <PagePermissionForm data={modal2.singleData} open={modal2.open} hideDialog={hideDialog2} toast={props.toast}></PagePermissionForm>
            <AddSubRoleForm permissions={props.permissions} open={subRoleForm.open} singledata={subRoleForm.singledata} toast={props.toast} hideHistory={hideHistory} />
        </>
    );
}
